import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface BadgeProps {
    children: string
    inverted?: boolean
    style?: StyleProp<ViewStyle>
}

const Badge: FC<BadgeProps> = ({ children, inverted, style }) => {
    const { styles } = useStyles(stylesheet, { inverted })

    return (
        <View style={[styles.container, style]}>
            <Typography.Menu style={[styles.text]}>{children}</Typography.Menu>
        </View>
    )
}

export default Badge

const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: 4,
        minWidth: 16,
        height: 16,
        borderRadius: 300,
        variants: {
            inverted: {
                true: {
                    backgroundColor: ColorEnum.BRICK_600,
                },
                false: {
                    backgroundColor: ColorEnum.WHITE,
                },
            },
        },
    },
    text: {
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 12,
        variants: {
            inverted: {
                true: {
                    color: ColorEnum.WHITE,
                },
                false: {
                    color: ColorEnum.BRICK_600,
                },
            },
        },
        // Android-specific centering
        textAlignVertical: 'center',
        includeFontPadding: false,
    },
})
